export function calcHeight(e,value) {
    //console.log(e)
    let numberOfLineBreaks = (value.match(/\n/g) || []).length;
    let newHeight = 1 + numberOfLineBreaks  
    document.getElementById(e).rows = newHeight
  }
  
export function calcHeight2(value) {
    let numberOfLineBreaks = (value.match(/\n/g) || []).length;
     // min-height + lines x line-height + padding + border
    let newHeight =  numberOfLineBreaks  
    return newHeight;
  }

  
 export const columns = (handleEdit,handleDelete) => [
    { field: 'rowNumber', headerName: 'No.', width: 80 },
     
    { field: 'id', headerName: 'Card Number', width: 200 },
    { field: 'descriptions', headerName: 'Name', width: 200 },
    { field: 'part_no', headerName: 'Amount', width: 150 },
    {
      field: 'actions',
      headerName: 'Actions',
      width: 350,
      renderCell: (params) => (
        <>
           <button
            onClick={() => handleEdit(params.row.id)} // Pass the project ID to the edit function
            className="btn btn-primary mr-2"
          >
            Edit
          </button>
        <button
          onClick={() => handleDelete(params.row.id)} // this delete button
          className="btn btn-danger"
        >
          Delete
        </button>&nbsp;
         
        </>
      ),
    },
  ];

  export const handleAdd = (code, rev, setRows) => {
    setRows((prev) =>
      [ // with a new array
        ...prev, // that contains all the old items
          { 
              rowNumber: prev.length + 1, 
              id : Math.random().toString().split('.')[1],
              descriptions:  "",
              name : "",
              newqty : 0,
              newhpp :0,
              newtotal :0,
              newqty2 :0,
              newhpp2 :0,
              newtotal2 :0,
             // part_no : Math.random(),
              raktype : "Service",
              product_type:2,
              part_no:'',
              isDb:false,
              isChecked : false,
              //code : code[code.length - 1]
              po_detail_id : -1,
              quotation_id : null,
              code:code,
              rev : rev,
              parent_id : null,
              rakid : -1
      },
      ]
    );
  }

 export const GetCode = (response) => {
    var code = response.filter((item)=>item.parent_id== null);
    var temp= [];
    var totalPo = 0;
    for(var i=0; i < code.length; i++) {
        if(temp.findIndex((x) =>x.code == code[i].code)  == -1) {
          var data ={
             code : code[i].code,
             total_project : code[i].totalpo
          }

          totalPo += code[i].totalpo;
          temp.push(data);
        }
    }

    return [totalPo, temp.sort()]
    
  }

  export const rowsWithRowNumbers = (response) => response.data.rak.map((row, index) => ({
    ...row,
    rowNumber: index + 1,
    id : Math.random().toString().split('.')[1],
    isDb : row.isDb,
    isChecked : row.isChecked,
  }));

  export function CalculateTotalSubDetail(rakid,rows){
    var totalHpp = 0;
    var total = 0;
   // console.log(rakid.rakid)
    if(rakid.rakid !== null){
      var newRows = rows.filter((item) => item.parent_id === rakid.rakid) ;
    
      if(newRows.length > 0){
        for(let i = 0;i < newRows.length;i++){
          totalHpp += parseInt(newRows[i].newhpp)
          total += parseInt(newRows[i].newtotal)
        }
       
        return {totalhpp : parseInt(total /  rakid.newqty), total : parseInt(total)}
      }else{
        return {totalhpp : (rakid.newtotal / rakid.newqty),total : rakid.newtotal}
      }
    }
    return {totalhpp : (rakid.newtotal / rakid.newqty),total : rakid.newtotal}
}

export function GetTotal1(rows, isExist){
    var  total = 0;
    var list = rows;
    for(let i=0; i < list.length; i++){
      if(list[i].parent_id != null){
        total += list[i].newtotal
      }
  
      if(list[i].parent_id == null && rows.filter((item)=> item.parent_id == (isExist ? list[i].rakid : list[i].po_detail_id)).length == 0){
        total += list[i].newtotal
      }
    }
    
    return total;
  }
  
  export function GetTotal2(rows){
    var  total = 0;
     for(let i=0; i < rows.length; i++){
      total += rows[i].newtotal2
     }
     return total;
  }
  
  export function GetTotal3(realizationList){
    var  total = 0;
    for(let i=0; i < realizationList.length; i++){
      if(realizationList[i].tipe == 'debit'){
        total += parseFloat(realizationList[i].debit == '' ? 0 : realizationList[i].debit)
      }
     
      if(realizationList[i].tipe == 'credit'){
        total -= parseFloat(realizationList[i].credit == '' ? 0 : realizationList[i].credit)
      }
    }
    
    return total;
  }

  export const handleAddRealization = (setRealizationList,id) => {
   
    setRealizationList((prev) => // Replace the state
      [ // with a new array
        ...prev, // that contains all the old items
          { 
              rowNumber: prev.length + 1, 
              id : Math.random().toString().split('.')[1],
              descriptions:  "",
              debit : 0,
              credit : 0,
              saldo :0,
              tipe: '',
              project_id : id
         },
      ]
    );
  }
